import _extends from "@babel/runtime/helpers/extends";
import { color } from "@smartsheet/design-tokens-react";
import React, { forwardRef } from "react";
import { Icon } from "../../icon/Icon";
import DragHandleIconSvg from "./DragHandleIconSvg";
export const DragHandleIcon = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    color: iconColor = color("color--background--neutral--strongest"),
    size,
    ...rest
  } = _ref;
  const DEFAULT_WIDTH = 8;
  const DEFAULT_HEIGHT = 18;
  const finalSize = {
    width: Number(size?.width) || DEFAULT_WIDTH,
    height: Number(size?.height) || DEFAULT_HEIGHT
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    color: iconColor,
    size: finalSize,
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(DragHandleIconSvg, {
    fillColor: iconColor,
    size: finalSize
  }));
});
DragHandleIcon.displayName = "DragHandleIcon";
//# sourceMappingURL=DragHandleIcon.js.map